import React, { useState, useEffect, useCallback } from 'react'
import styled from 'styled-components'

const Table = styled.table`
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
  background-color: transparent;
  border-collapse: collapse;
  border-spacing: 0;
`

const Field = styled.th`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  text-align: left;
`

const Data = styled.td`
  border-top: 1px solid #f4f4f4;
  padding: 8px;
  line-height: 1.42857143;
  vertical-align: top;
  display: table-cell;
`

const List = ({
  fieldList,
  dataList,
  clickE,
  isClick,
  setDatas,
  setPtag,
  isAssistant,
  assistantUpdate,
  assistantDelete,
  statusUpdate,
  isAssistantDev,
  assistantToLive,
  toRoyalChat,
  assistantToDMM
}) => {
  return (
    <Table>
      <tbody>
        <tr>
          {fieldList.map((field, index) => {
            return (
              field !== 'assistantInfo' && <Field key={index}>{field}</Field>
            )
          })}
        </tr>
        {dataList.map((data, index) => {
          let list = []

          for (const field of fieldList) {
            if (field === 'stickerImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'profileImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'nudity') {
              list.push(
                <td key={field + index}>
                  {data[field] ? data[field][0].type : null}
                </td>
              )
            } else if (field === 'assistantImg') {
              list.push(
                <td key={field + index}>
                  <img src={data[field]} style={{ width: 100, height: 100 }} />
                </td>
              )
            } else if (field === 'instructions') {
              list.push(
                <td
                  key={field + index}
                  style={{ maxWidth: 200, overflow: 'hidden' }}
                >
                  {data[field]}
                </td>
              )
            } else if (field === 'assistantStatus') {
              list.push(
                <Data
                  key={field + index}
                  style={{ display: 'flex', flexDirection: 'column' }}
                >
                  {data[field]}
                  <div style={{ display: 'flex' }}>
                    <button
                      onClick={() => statusUpdate(data['assistantId'], 'Y')}
                    >
                      활성화
                    </button>
                    <button
                      onClick={() => statusUpdate(data['assistantId'], 'N')}
                    >
                      비활성화
                    </button>
                  </div>
                </Data>
              )
            } else if (field !== 'assistantInfo') {
              if (field === 'assistantId') {
                list.push(
                  <>
                    <Data key={field + index}>
                      {data[field]}
                      <br />
                      <button
                        onClick={() => {
                          window.open(
                            `https://stipop.com/chat/${btoa(data[field])}`,
                            '_blank'
                          )
                        }}
                      >
                        이동
                      </button>
                      <button
                        onClick={() => {
                          assistantToDMM(data)
                        }}
                      >
                        DMM 복사
                      </button>
                    </Data>
                  </>
                )
              } else {
                list.push(
                  <Data key={field + index} onClick={() => {}}>
                    {data[field]}
                  </Data>
                )
              }
            }
          }

          if (isAssistant) {
            if (isAssistantDev) {
              list.push(
                <>
                  <td key={99999}>
                    <button onClick={() => assistantUpdate(data)}>수정</button>
                    <button onClick={() => assistantToLive(data)}>
                      Live 옮기기
                    </button>
                  </td>
                </>
              )
            } else {
              list.push(
                <>
                  <td key={99999}>
                    <button onClick={() => assistantUpdate(data)}>수정</button>
                    {/* <button onClick={() => toRoyalChat(data)}>To royal</button> */}
                  </td>
                </>
              )
            }
          }

          return <tr key={index}>{list}</tr>
        })}
      </tbody>
    </Table>
  )
}

export default List
